import { render, staticRenderFns } from "./C19DeclarationReport.vue?vue&type=template&id=5bda75c1&scoped=true"
import script from "./C19DeclarationReport.vue?vue&type=script&lang=js"
export * from "./C19DeclarationReport.vue?vue&type=script&lang=js"
import style0 from "./C19DeclarationReport.vue?vue&type=style&index=0&id=5bda75c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bda75c1",
  null
  
)

export default component.exports